module.exports = __webpack_public_path__ + "img/img-2-2.897af057.png";